/**
 * 聚水潭 ERP 第四章「订单查询」场景，素材对应《聚水潭功能学习》PPT 第 46-48 页。
 */

import {
  JST_TARGETS,
  JST_ORDER_QUERY_ROWS,
  JST_AFTERSALE_FAST_ROWS as NORMALIZED_AFTERSALE_FAST_ROWS,
  JST_AFTERSALE_RETURN_ROWS as NORMALIZED_AFTERSALE_RETURN_ROWS,
  JST_AFTERSALE_RETURN_GOODS_BY_ID as NORMALIZED_AFTERSALE_RETURN_GOODS_BY_ID
} from './jstErpFixtureData'
import { red } from './jstTip'

function r(path) {
  return require('@/assets/images/jushuitan/' + path)
}

const TARGET_ORDER_CODE = JST_TARGETS.orderQuery
const TARGET_AFTERSALE_ORDER_CODE = JST_TARGETS.aftersaleQuery
const ORDER_QUERY_TIP = '在' + red('订单页面') + '查询线上订单号' + red(TARGET_ORDER_CODE) + '的售后'
const AFTERSALE_RETURN_QUERY_TIP = '在' + red('售后（退货退款）') + '查询线上订单号' + red(TARGET_AFTERSALE_ORDER_CODE) + '的售后'
const AFTERSALE_FAST_QUERY_TIP = '在' + red('售后极速版') + '查询线上订单号' + red(TARGET_AFTERSALE_ORDER_CODE) + '的售后'
const LOGOUT_TIP = '退出聚水潭'
const SCENE_IMAGES = {
  login: r('jst_login.png'),
  home: r('1-0.png'),
  homeMenu: r('1-1.png'),
  orderResult: r('4-1-order-query-result.png'),
  aftersaleQuery: r('4-2-aftersale-query.png'),
  aftersaleResult: r('4-3-aftersale-query-result.png')
}

const DEFAULT_GOODS_THUMBNAIL = r('order-default-necklace.png')

const ORDER_QUERY_ROWS = JST_ORDER_QUERY_ROWS.map(row => ({ ...row, goods: DEFAULT_GOODS_THUMBNAIL }))

const ORDER_QUERY_COLUMNS = [
  { key: 'internalOrderNo', title: '内部订单号', width: 96 },
  { key: 'tags', title: '标记及多标签', width: 94, align: 'center' },
  { key: 'goods', type: 'image', title: '商品', width: 92, align: 'center' },
  { key: 'onlineOrderNo', title: '线上订单号', width: 142, whiteSpace: 'pre-line' },
  { key: 'externalOrderNo', title: '外部交易', width: 64 },
  { key: 'orderTime', title: '下单时间', width: 126, whiteSpace: 'pre-line' },
  { key: 'paymentTime', title: '付款时间', width: 126, whiteSpace: 'pre-line' },
  { key: 'auditTime', title: '审核时间', width: 118, whiteSpace: 'pre-line' },
  { key: 'buyer', title: '买家账号及店铺', width: 144, whiteSpace: 'pre-line' },
  { key: 'payable', title: '应付金额及运费', width: 78, align: 'right', whiteSpace: 'pre-line' },
  { key: 'profit', title: '利润', width: 50, align: 'right' },
  { key: 'paidAmount', title: '已付金额', width: 78, align: 'right' },
  { key: 'additional', title: '附加信息', width: 90, align: 'right', whiteSpace: 'pre-line' },
  { key: 'status', title: '状态', width: 92, align: 'center', whiteSpace: 'pre-line' },
  { key: 'suggestion', title: '处理建议', width: 192, whiteSpace: 'pre-line' }
]

function buildOrderQueryTables(rows = ORDER_QUERY_ROWS) {
  return [{
    id: 'fourth-order-query-table',
    x: 0.146, y: 0.17, w: 0.858, h: 0.804,
    fontSize: 9,
    rowHeight: 66,
    rows,
    columns: ORDER_QUERY_COLUMNS.map(column => ({
      ...column,
      cellStyle: row => {
        const style = { color: '#454545', verticalAlign: 'middle' }
        if (row.selected) style.background = '#dcecff'
        if (column.key === 'status') {
          if (row.status === '发货中') Object.assign(style, { color: '#1689c9', background: '#d9f1fd', fontWeight: '700' })
          if (row.status.indexOf('已付款待审核') > -1) Object.assign(style, { background: '#ffe7a3' })
          if (row.status.indexOf('异常') > -1) Object.assign(style, { color: '#fff', background: '#b38d4f', fontWeight: '700' })
        }
        if (column.key === 'suggestion') style.fontSize = '9px'
        return style
      }
    })),
    rowKey: 'id',
    selectable: true
  }]
}

const AFTERSALE_FAST_ROWS = NORMALIZED_AFTERSALE_FAST_ROWS

const AFTERSALE_FAST_COLUMNS = [
  { key: 'aftersaleNo', title: '售后单号', width: 126 },
  { key: 'internalOrderNo', title: '内部订单号', width: 116 },
  { key: 'aftersaleStatus', title: '售后单状态', width: 92, align: 'center' },
  { key: 'solution', title: '解决方案', width: 82 },
  { key: 'onlineStatus', title: '线上状态', width: 120 },
  { key: 'onlineType', title: '线上类型', width: 92 },
  { key: 'aftersaleCategory', title: '售后分类', width: 92 },
  { key: 'goodsInfo', title: '商品信息', width: 220, whiteSpace: 'pre-line' },
  { key: 'returnExpressNo', title: '退货快递单号', width: 138 },
  { key: 'returnInternationalNo', title: '退货国际单号', width: 138 },
  { key: 'cargoStatus', title: '货物状态', width: 100 },
  { key: 'interceptStatus', title: '快递拦截状态', width: 120 },
  { key: 'interceptReason', title: '拦截失败原因', width: 128 },
  { key: 'interceptTime', title: '快递拦截时间', width: 124 },
  { key: 'receivingWarehouse', title: '收货仓', width: 90 },
  { key: 'warehouse', title: '仓库', width: 148, whiteSpace: 'pre-line' },
  { key: 'onlineOrderNo', title: '线上订单号', width: 154, whiteSpace: 'pre-line' },
  { key: 'onlineAftersaleNo', title: '线上售后单号', width: 154 },
  { key: 'issueType', title: '售后问题类型', width: 128 },
  { key: 'tags', title: '售后标签', width: 96 },
  { key: 'issueRecord', title: '售后问题登记', width: 160 },
  { key: 'supplierMemo', title: '供分销备注', width: 156 },
  { key: 'supplierAftersaleStatus', title: '供应商售后单状态', width: 128 },
  { key: 'workOrder', title: '聚工单', width: 88 },
  { key: 'buyer', title: '买家账号', width: 90 },
  { key: 'receiver', title: '收货信息', width: 160, whiteSpace: 'pre-line' },
  { key: 'store', title: '店铺', width: 114, whiteSpace: 'pre-line' },
  { key: 'exceptionStatus', title: '异常状态', width: 96 },
  { key: 'supplierRefundStatus', title: '供应商退款状态', width: 128 },
  { key: 'applyTime', title: '申请时间', width: 118, whiteSpace: 'pre-line' },
  { key: 'confirmTime', title: '确认时间', width: 118, whiteSpace: 'pre-line' },
  { key: 'originalOrderStatus', title: '原订单状态', width: 100 },
  { key: 'orderStatusSnapshot', title: '订单状态快照', width: 122 },
  { key: 'deliveryExpressNo', title: '发货快递单号', width: 148, whiteSpace: 'pre-line' },
  { key: 'deliveryInternationalNo', title: '发货国际单号', width: 138 },
  { key: 'originalTags', title: '原订单标签', width: 178, whiteSpace: 'pre-line' },
  { key: 'originalWarehouse', title: '原订单发货仓', width: 132, whiteSpace: 'pre-line' },
  { key: 'originalRemark', title: '原订单备注/旗帜', width: 126 },
  { key: 'originalOfflineRemark', title: '原订单线下备注', width: 126 },
  { key: 'originalSalesman', title: '原订单业务员', width: 118 },
  { key: 'originalPurchaseAmount', title: '原订单采购金额', width: 128, align: 'right' },
  { key: 'originalOrderAmount', title: '原订单下单金额', width: 136, align: 'right', whiteSpace: 'pre-line' },
  { key: 'onlineApplyAmount', title: '线上申请金额', width: 126, align: 'right' },
  { key: 'refundedAmount', title: '实退金额', width: 126, align: 'right', whiteSpace: 'pre-line' },
  { key: 'actualReceivedAmount', title: '实际收货金额', width: 126, align: 'right' },
  { key: 'applyReturnQty', title: '申请退货数量', width: 100, align: 'right' },
  { key: 'actualReturnQty', title: '实退数量', width: 90, align: 'right' },
  { key: 'creator', title: '创建人', width: 90 },
  { key: 'modifier', title: '修改人', width: 90 },
  { key: 'platformDetail', title: '平台售后详情', width: 160 },
  { key: 'arbitrationStatus', title: '仲裁状态', width: 110 },
  { key: 'actions', title: '操作', width: 94, align: 'center', whiteSpace: 'pre-line' }
]

function buildAftersaleFastTables(rows = AFTERSALE_FAST_ROWS) {
  return [{
    id: 'fourth-aftersale-fast-table',
    x: 0.04, y: 0.63, w: 0.95, h: 0.34,
    fontSize: 9,
    rowHeight: 70,
    rows,
    columns: AFTERSALE_FAST_COLUMNS.map(column => ({
      ...column,
      cellStyle: row => {
        const style = { color: '#454545', verticalAlign: 'middle' }
        if (column.key === 'aftersaleStatus' && row.aftersaleStatus === '待确认') Object.assign(style, { color: '#ff8a21', fontWeight: '700' })
        if (['aftersaleNo', 'internalOrderNo', 'onlineOrderNo', 'buyer', 'deliveryExpressNo', 'platformDetail', 'actions'].indexOf(column.key) > -1) style.color = '#1697ec'
        if (column.key === 'tags') Object.assign(style, { color: '#52769d', background: '#dfe8f5' })
        return style
      }
    })),
    rowKey: 'id',
    selectable: true
  }]
}

const AFTERSALE_RETURN_ROWS = NORMALIZED_AFTERSALE_RETURN_ROWS
const AFTERSALE_RETURN_GOODS_BY_ID = Object.keys(NORMALIZED_AFTERSALE_RETURN_GOODS_BY_ID).reduce((result, key) => {
  result[key] = NORMALIZED_AFTERSALE_RETURN_GOODS_BY_ID[key].map(row => ({ ...row, thumbnail: DEFAULT_GOODS_THUMBNAIL }))
  return result
}, {})

function buildAftersaleReturnTables({ ui }, rows = AFTERSALE_RETURN_ROWS) {
  const selectedKeys = ui['fourth-aftersale-return-tableSelectedKeys'] || []
  const goodsRows = AFTERSALE_RETURN_GOODS_BY_ID[selectedKeys[0]] || []

  return [{
    id: 'fourth-aftersale-return-table',
    x: 0.165, y: 0.18, w: 0.84, h: 0.54, cursor: 'pointer',
    rows,
    columns: [
      { key: 'aftersaleNo', title: '售后单号', width: 126 },
      { key: 'businessType', title: '业务类型', width: 92 },
      { key: 'internalOrderNo', title: '内部订单号', width: 120 },
      { key: 'applyTime', title: '申请日期', width: 160 },
      { key: 'onlineType', title: '线上类型', width: 92 },
      { key: 'aftersaleCategory', title: '售后分类', width: 92 },
      { key: 'status', title: '状态', width: 78 },
      { key: 'onlineStatus', title: '线上状态', width: 100 },
      { key: 'cargoStatus', title: '货物状态', width: 120 },
      { key: 'buyerAccount', title: '买家账号', width: 96 },
      { key: 'externalTradeNo', title: '外部交易单号', width: 130 },
      { key: 'receivingWarehouse', title: '收货仓', width: 96 },
      { key: 'warehouse', title: '仓库', width: 110 },
      { key: 'returnLogistics', title: '退回物流商渠道', width: 130 },
      { key: 'returnInternationalNo', title: '退回国际单号', width: 130 }
    ],
    rowKey: 'id',
    selectable: true,
    selectionType: 'radio',
    selectedKeys
  }, {
    id: 'fourth-aftersale-return-goods-table',
    x: 0.165, y: 0.76, w: 0.84, h: 0.21,
    rows: goodsRows,
    columns: [
      { key: 'thumbnail', type: 'image', title: '缩略图', width: 68 },
      { key: 'goodsCode', title: '商品编码', width: 150 },
      { key: 'comboGoodsCode', title: '组合商品编码', width: 150 },
      { key: 'styleCode', title: '款式编码', width: 118 },
      { key: 'goodsName', title: '商品名称', width: 270 },
      { key: 'spec', title: '颜色及规格', width: 220 },
      { key: 'goodsTag', title: '商品标签', width: 110 },
      { key: 'onlineDetailAmount', title: '线上明细金额', width: 120, align: 'right' },
      { key: 'unitPrice', title: '单价', width: 88, align: 'right' },
      { key: 'applyQty', title: '申请数量', width: 88, align: 'right' },
      { key: 'actualReturnQty', title: '实退数量', width: 88, align: 'right' }
    ],
    rowKey: 'id'
  }]
}

export function getJstErpOrderQueryScenario() {
  return {
    initialStepId: 'home',
    initialForm: { orderCode: '', aftersaleOrderCode: '' },
    steps: [
      {
        id: 'home',
        image: SCENE_IMAGES.home,
        aspectRatio: 2,
        tip: ORDER_QUERY_TIP,
        hotspots: [{
          id: 'open-order-menu', x: 0, y: 0.06, w: 0.03, h: 0.06,
          highlight: 'primary', next: 'home-menu-order'
        }]
      },
      {
        id: 'home-menu-order',
        image: SCENE_IMAGES.homeMenu,
        aspectRatio: 2,
        tip: ORDER_QUERY_TIP,
        hotspots: [{
          id: 'enter-order', x: 0.175, y: 0.155, w: 0.075, h: 0.035,
          highlight: 'primary', next: 'order-query'
        }, {
          id: 'common-order', x: 0.04, y: 0.055, w: 0.10, h: 0.032,
          highlight: 'primary', next: 'order-query'
        }]
      },
      {
        id: 'order-query',
        image: SCENE_IMAGES.orderResult,
        aspectRatio: 2,
        tip: ORDER_QUERY_TIP,
        fields: [{
          id: 'order-code', model: 'orderCode', type: 'text', bgColor: '#fff', fontSize: 10,
          placeholder: '线上订单号', x: 0.034, y: 0.107, w: 0.06, h: 0.022,
          onEnter: ({ form, go }) => {
            if (String(form.orderCode || '').trim() === TARGET_ORDER_CODE) {
              go('order-done')
              return
            }
            return { ok: false, msg: '请输入正确的线上订单号 ' + TARGET_ORDER_CODE }
          }
        }],
        tables: () => buildOrderQueryTables()
      },
      {
        id: 'order-done',
        image: SCENE_IMAGES.orderResult,
        aspectRatio: 2,
        fields: [{
          id: 'order-code-result', model: 'orderCode', type: 'text', bgColor: '#fff', fontSize: 10,
          placeholder: '线上订单号', x: 0.034, y: 0.107, w: 0.06, h: 0.022
        }],
        tables: () => buildOrderQueryTables(ORDER_QUERY_ROWS.filter(row => row.onlineOrderNo === TARGET_ORDER_CODE)),
        tip: ORDER_QUERY_TIP,
        afterEnter: { delay: 2000, go: 'home-after-order' }
      },
      {
        id: 'home-after-order',
        image: SCENE_IMAGES.home,
        aspectRatio: 2,
        tip: AFTERSALE_RETURN_QUERY_TIP,
        hotspots: [{
          id: 'open-menu-after-order', x: 0, y: 0.06, w: 0.03, h: 0.06,
          highlight: 'primary', next: 'home-menu-aftersale-return'
        }]
      },
      {
        id: 'home-menu-aftersale-fast',
        image: SCENE_IMAGES.homeMenu,
        aspectRatio: 2,
        tip: AFTERSALE_FAST_QUERY_TIP,
        hotspots: [{
          id: 'enter-aftersale-fast', x: 0.294, y: 0.122, w: 0.084, h: 0.03,
          highlight: 'primary', next: 'aftersale-fast'
        }, {
          id: 'common-aftersale-fast', x: 0.04, y: 0.524, w: 0.10, h: 0.032,
          highlight: 'primary', next: 'aftersale-fast'
        }]
      },
      {
        id: 'aftersale-fast',
        image: SCENE_IMAGES.aftersaleQuery,
        aspectRatio: 2,
        tip: AFTERSALE_FAST_QUERY_TIP,
        fields: [{
          id: 'aftersale-order-code', model: 'aftersaleOrderCode', type: 'text', bgColor: '#fff', fontSize: 11,
          placeholder: '线上订单号', x: 0.425, y: 0.384, w: 0.07, h: 0.022
        }],
        tables: () => buildAftersaleFastTables(),
        hotspots: [{
          id: 'search-aftersale', x: 0.915, y: 0.467, w: 0.045, h: 0.03, highlight: 'primary',
          guard: ({ form }) => String(form.aftersaleOrderCode || '').trim() === TARGET_AFTERSALE_ORDER_CODE
            ? { ok: true }
            : { ok: false, msg: '请输入正确的订单号 ' + TARGET_AFTERSALE_ORDER_CODE },
          next: 'aftersale-fast-done'
        }]
      },
      {
        id: 'aftersale-fast-done',
        image: SCENE_IMAGES.aftersaleQuery,
        aspectRatio: 2,
        fields: [{
          id: 'aftersale-order-code-result', model: 'aftersaleOrderCode', type: 'text', bgColor: '#fff', fontSize: 11,
          placeholder: '线上订单号', x: 0.425, y: 0.384, w: 0.07, h: 0.022
        }],
        tables: () => buildAftersaleFastTables(AFTERSALE_FAST_ROWS.filter(row => row.onlineOrderNo === TARGET_AFTERSALE_ORDER_CODE)),
        tip: AFTERSALE_FAST_QUERY_TIP,
        afterEnter: { delay: 2000, go: 'home-exit' }
      },
      {
        id: 'home-exit',
        image: SCENE_IMAGES.home,
        aspectRatio: 2,
        tip: LOGOUT_TIP,
        hotspots: [{
          id: 'open-merchant-menu', x: 0.875, y: 0.006, w: 0.12, h: 0.04,
          highlight: 'primary', next: 'merchant-menu'
        }]
      },
      {
        id: 'merchant-menu',
        image: SCENE_IMAGES.home,
        aspectRatio: 2,
        tip: LOGOUT_TIP,
        labels: [
          { id: 'merchant-menu-panel', text: '', x: 0.883, y: 0.04, w: 0.105, h: 0.385, bgColor: '#fff' },
          { id: 'merchant-menu-logout', text: '退出', x: 0.891, y: 0.052, w: 0.085, h: 0.026, fontSize: 13, justifyContent: 'flex-start' },
          { id: 'merchant-menu-switch', text: '切换分仓　›', x: 0.891, y: 0.094, w: 0.085, h: 0.026, fontSize: 13, justifyContent: 'flex-start' },
          { id: 'merchant-menu-account', text: '账号密码管理　›', x: 0.891, y: 0.136, w: 0.09, h: 0.026, fontSize: 13, justifyContent: 'flex-start' },
          { id: 'merchant-menu-print-download', text: '打印控件下载', x: 0.891, y: 0.178, w: 0.085, h: 0.026, fontSize: 13, justifyContent: 'flex-start' },
          { id: 'merchant-menu-print-test', text: '打印测试工具', x: 0.891, y: 0.22, w: 0.085, h: 0.026, fontSize: 13, justifyContent: 'flex-start' },
          { id: 'merchant-menu-cloud', text: '下载聚水云', x: 0.891, y: 0.262, w: 0.085, h: 0.026, fontSize: 13, justifyContent: 'flex-start' },
          { id: 'merchant-menu-feedback', text: '建议反馈', x: 0.891, y: 0.304, w: 0.085, h: 0.026, fontSize: 13, justifyContent: 'flex-start' },
          { id: 'merchant-menu-service', text: '商家服务账单', x: 0.891, y: 0.346, w: 0.085, h: 0.026, fontSize: 13, justifyContent: 'flex-start' },
          { id: 'merchant-menu-support', text: '联系售后', x: 0.891, y: 0.388, w: 0.085, h: 0.026, fontSize: 13, justifyContent: 'flex-start' }
        ],
        hotspots: [{
          id: 'logout', x: 0.883, y: 0.046, w: 0.105, h: 0.04,
          highlight: 'primary', next: 'logout-login'
        }]
      },
      {
        id: 'logout-login',
        image: SCENE_IMAGES.login,
        aspectRatio: 2,
        tip: LOGOUT_TIP,
        afterEnter: { delay: 2000, finish: true }
      },
      {
        id: 'home-after-aftersale-return',
        image: SCENE_IMAGES.home,
        aspectRatio: 2,
        afterEnter: { setForm: { aftersaleOrderCode: '' } },
        tip: AFTERSALE_FAST_QUERY_TIP,
        hotspots: [{
          id: 'open-menu-after-aftersale-return', x: 0, y: 0.06, w: 0.03, h: 0.06,
          highlight: 'primary', next: 'home-menu-aftersale-fast'
        }]
      },
      {
        id: 'home-menu-aftersale-return',
        image: SCENE_IMAGES.homeMenu,
        aspectRatio: 2,
        tip: AFTERSALE_RETURN_QUERY_TIP,
        hotspots: [{
          id: 'enter-aftersale-return', x: 0.294, y: 0.059, w: 0.11, h: 0.028,
          highlight: 'primary', next: 'aftersale-return'
        }, {
          id: 'common-aftersale-return', x: 0.04, y: 0.094, w: 0.10, h: 0.03,
          highlight: 'primary', next: 'aftersale-return'
        }]
      },
      {
        id: 'aftersale-return',
        image: SCENE_IMAGES.aftersaleResult,
        aspectRatio: 2,
        tip: AFTERSALE_RETURN_QUERY_TIP,
        fields: [{
          id: 'aftersale-return-order-code', model: 'aftersaleOrderCode', type: 'text', bgColor: '#fff', fontSize: 10,
          placeholder: '线上订单号', x: 0.055, y: 0.165, w: 0.06, h: 0.02,
          onEnter: ({ form, go, setUi }) => {
            if (String(form.aftersaleOrderCode || '').trim() === TARGET_AFTERSALE_ORDER_CODE) {
              setUi({
                'fourth-aftersale-return-tableSelectedKeys': [],
                'fourth-aftersale-return-tableSelectedRows': []
              })
              go('aftersale-return-done')
              return
            }
            return { ok: false, msg: '请输入正确的订单号 ' + TARGET_AFTERSALE_ORDER_CODE }
          }
        }],
        tables: context => buildAftersaleReturnTables(context)
      },
      {
        id: 'aftersale-return-done',
        image: SCENE_IMAGES.aftersaleResult,
        aspectRatio: 2,
        fields: [{
          id: 'aftersale-return-order-code-result', model: 'aftersaleOrderCode', type: 'text', bgColor: '#fff', fontSize: 10,
          placeholder: '线上订单号', x: 0.055, y: 0.165, w: 0.06, h: 0.02
        }],
        tables: context => buildAftersaleReturnTables(context, AFTERSALE_RETURN_ROWS.filter(row => row.onlineOrderNo === TARGET_AFTERSALE_ORDER_CODE)),
        tip: AFTERSALE_RETURN_QUERY_TIP,
        afterEnter: { delay: 2000, go: 'home-after-aftersale-return' }
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/page/simulate/jushuitan/jstErpOrderQueryScenarios.js